import "./App.css";
import RouteList from "./Common/RouteList";
import 'react-loading-skeleton/dist/skeleton.css'
function App() {
  return <RouteList />;
}

export default App;
